module.exports = __webpack_public_path__ + "static/media/kmaster.2cb2afa4.svg";